import { useMemo } from "react";
import { SortDescriptor } from "react-aria-components";

import { ManagedUserGroupIntegration } from "types/generated";

import { sortIntegrations } from "./sort";

export const useFilteredIntegrations = (
  integrations: ManagedUserGroupIntegration[],
  sortDescriptor: SortDescriptor
) => {
  return useMemo(() => {
    let filteredIntegrations = [...integrations];

    if (sortDescriptor.column) {
      filteredIntegrations = sortIntegrations(filteredIntegrations, sortDescriptor);
    }

    return filteredIntegrations;
  }, [integrations, sortDescriptor]);
};
